module.exports = __webpack_public_path__ + "static/img/subbanner1.d56ef13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banners/subbanner1.jpg
// module id = xa4t
// module chunks = 1